import { LanguageType } from '@/custom-types';
import { useUserLanguage } from '@/customHooks';
import { DepositStatusOption } from '@/graphql/generated';

type DepositStatusOptionPillProps = {
  option: DepositStatusOption;
};

const optionMapping = (option: DepositStatusOption, language: LanguageType) => {
  const pendingStyle = {
    textColor: 'text-[#FF971D]',
    bgColor: 'bg-[#FF971D21]',
  };

  const receivedStyle = {
    textColor: 'text-[#4a9462]',
    bgColor: 'bg-[#d2f3dc]',
  };

  const returnedStyle = {
    textColor: 'text-[#ff7878]',
    bgColor: 'bg-[#ffd7d7]',
  };

  const cancelledStyle = {
    textColor: 'text-[#ff7878]',
    bgColor: 'bg-[#ffd7d7]',
  };

  const mapping = {
    en: {
      [DepositStatusOption.Pending]: { text: 'Pending', ...pendingStyle },
      [DepositStatusOption.Received]: { text: 'Received', ...receivedStyle },
      [DepositStatusOption.Returned]: { text: 'Returned', ...returnedStyle },
      [DepositStatusOption.Cancelled]: { text: 'Cancelled', ...cancelledStyle },
    },
    es: {
      [DepositStatusOption.Pending]: { text: 'Pendiente', ...pendingStyle },
      [DepositStatusOption.Received]: { text: 'Recibido', ...receivedStyle },
      [DepositStatusOption.Returned]: { text: 'Devuelto', ...returnedStyle },
      [DepositStatusOption.Cancelled]: { text: 'Cancelado', ...cancelledStyle },
    },
  };

  return mapping[language][option];
};

export const DepositStatusOptionPill = ({ option }: DepositStatusOptionPillProps) => {
  const userLanguage = useUserLanguage();

  const mapped = optionMapping(option, userLanguage);

  return (
    <span
      className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-bold ${mapped.textColor} ${mapped.bgColor}`}
    >
      {mapped.text}
    </span>
  );
};
